import { IProcessItem } from "interfaces/IItemsOrder"
import {
  ProductsContainer,
  ProductRow,
  ProductsWrapperContainer,
} from "./ViewProductsList.styled"

interface ViewProductsListProps {
  itemsOrder: Array<IProcessItem>
  titleMain?: string
}

/*
const ProductItemCard = ({ item }: { item: IProcessItem }) => {

  return (
    <ProductCardFlex>
      <div className="product-info-container">
        <p className="product-name-title">{item.name}</p>
        <div className="product-details-grid">
          {item?.sku &&
            <div className="detail-field" >
              <span className="field-label">Sku:</span>
              <span className="field-value">{item.sku}</span>
            </div>
          }
          {item?.quantity &&
            <div className="detail-field" >
              <span className="field-label">Cantidad:</span>
              <span className="field-value">{item.quantity}</span>
            </div>
          }
        </div>
      </div>
    </ProductCardFlex>
  )
}
*/

const ViewProductsList = ({ itemsOrder, titleMain }: ViewProductsListProps) => {
  return (
    <ProductsContainer>
      {titleMain && (
        <div className="products-title-banner">
          <span>{titleMain}</span>
        </div>
      )}
      <ProductsWrapperContainer>
        {/*itemsOrder.map((item) => (
          <ProductItemRow key={item.sku} item={item} />
        ))*/}
        {itemsOrder.map((item) =>
          <div className="item" key={item.sku}>
            {item?.name && (
              <ProductRow className="no-border">
                <div className="field-row">
                  <span className="field-label">Nombre del Producto:</span>
                  <span className="field-value">{item.name}</span>
                </div>
              </ProductRow>
            )}
            {item?.sku && (
              <ProductRow className="no-border">
                <div className="field-row">
                  <span className="field-label">Sku:</span>
                  <span className="field-value">{item.sku}</span>
                </div>
              </ProductRow>
            )}
            {item?.quantity && (
              <ProductRow className="no-border">
                <div className="field-row">
                  <span className="field-label">Cantidad:</span>
                  <span className="field-value">{item.quantity}</span>
                </div>
              </ProductRow>
            )}
          </div>
        )}
      </ProductsWrapperContainer>
    </ProductsContainer>
  )
}

export default ViewProductsList
